import { render, staticRenderFns } from "./MapaPeligroControl.vue?vue&type=template&id=6e62efb7&scoped=true"
import script from "./MapaPeligroControl.vue?vue&type=script&lang=ts"
export * from "./MapaPeligroControl.vue?vue&type=script&lang=ts"
import style0 from "./MapaPeligroControl.vue?vue&type=style&index=0&id=6e62efb7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e62efb7",
  null
  
)

export default component.exports